import type { DataLayerBase, YesNo } from '../data-layer-service';
import { PageViewPayload, stripUndefinedFields } from './transform';

const convertDateToISOFormat = (timestamp) => {
    const date = new Date(timestamp);
    return date.toISOString();
};

const toStringUnlessUndefined = (val: number | undefined) => {
    if (val) {
        return val.toString();
    } else {
        return undefined;
    }
};

export const toBooleanUnlessUndefined = (val: YesNo) => {
    if (val === 'Yes' || val === 'yes' || val === 'Y') {
        return true;
    } else if (val === 'No' || val === 'no' || val === 'N') {
        return false;
    } else {
        return undefined;
    }
};

export const parseDatalayer = (dataLayerBase: DataLayerBase): PageViewPayload => {
    return (
        stripUndefinedFields({
            pageType: dataLayerBase?.p?.t,
            platform: dataLayerBase?.p?.pl,
            vehicle: {
                make: dataLayerBase?.a?.attr?.vehicle_make || dataLayerBase?.s?.attr?.vehicle_make,
                model:
                    dataLayerBase?.a?.attr?.vehicle_model || dataLayerBase?.s?.attr?.vehicle_model,
                transmission:
                    dataLayerBase?.a?.attr?.vehicle_transimission ||
                    dataLayerBase?.s?.attr?.vehicle_transimission,
                fuelType:
                    dataLayerBase?.a?.attr?.vehicle_fuel_type ||
                    dataLayerBase?.s?.attr?.vehicle_fuel_type,
            },
            pets: {
                catBreed: dataLayerBase?.a?.attr?.cat_breed || dataLayerBase?.s?.attr?.cat_breed,
                dogBreed: dataLayerBase?.a?.attr?.dog_breed || dataLayerBase?.s?.attr?.dog_breed,
                isDeflead: toBooleanUnlessUndefined(
                    dataLayerBase?.a?.attr?.deflead || dataLayerBase?.s?.attr?.deflead
                ),
                isVaccinated: toBooleanUnlessUndefined(
                    dataLayerBase?.a?.attr?.vaccinated || dataLayerBase?.s?.attr?.vaccinated
                ),
                isMicrochipped: toBooleanUnlessUndefined(
                    dataLayerBase?.a?.attr?.microchipped || dataLayerBase?.s?.attr?.microchipped
                ),
                isNeuteredOrSpayed: toBooleanUnlessUndefined(
                    dataLayerBase?.a?.attr?.neutered_or_spayed ||
                        dataLayerBase?.s?.attr?.neutered_or_spayed
                ),
            },
            ad: {
                id: toStringUnlessUndefined(dataLayerBase?.a?.id),
                user: {
                    type: dataLayerBase?.a?.u?.at,
                },
                sellerType: dataLayerBase?.a?.attr?.seller_type,
                ...(dataLayerBase?.a?.prc?.amt && {
                    price: {
                        amount:
                            typeof dataLayerBase.a.prc.amt === 'string'
                                ? parseInt(dataLayerBase.a.prc.amt)
                                : dataLayerBase.a.prc.amt,
                        ...(dataLayerBase.a.prc.cur && {
                            currency: dataLayerBase.a.prc.cur,
                        }),
                    },
                }),
                descriptionLength: dataLayerBase?.a?.dl,
                imageCount: dataLayerBase?.a?.ic,
                creationDate: dataLayerBase?.a?.cdt && convertDateToISOFormat(dataLayerBase.a.cdt),
                lastPublishedDate:
                    dataLayerBase?.a?.lpdt && convertDateToISOFormat(dataLayerBase.a.lpdt),
                advertClickSource: dataLayerBase?.a?.acs,
            },
            category: {
                l0: {
                    id: toStringUnlessUndefined(dataLayerBase?.c?.l0?.id),
                },
                l1: {
                    id: toStringUnlessUndefined(dataLayerBase?.c?.l1?.id),
                },
                l2: {
                    id: toStringUnlessUndefined(dataLayerBase?.c?.l2?.id),
                },
                l3: {
                    id: toStringUnlessUndefined(dataLayerBase?.c?.l3?.id),
                },
                l4: {
                    id: toStringUnlessUndefined(dataLayerBase?.c?.l4?.id),
                },
            },
            location: {
                l0: {
                    id: toStringUnlessUndefined(dataLayerBase?.l?.l0?.id),
                },
                l1: {
                    id: toStringUnlessUndefined(dataLayerBase?.l?.l1?.id),
                },
                l2: {
                    id: toStringUnlessUndefined(dataLayerBase?.l?.l2?.id),
                },
                l3: {
                    id: toStringUnlessUndefined(dataLayerBase?.l?.l3?.id),
                },
                l4: {
                    id: toStringUnlessUndefined(dataLayerBase?.l?.l4?.id),
                },
            },
            search: {
                type: dataLayerBase?.s?.t,
                keyword: dataLayerBase?.s?.kw,
                pageNumber: dataLayerBase?.s?.pn,
                totalResults: dataLayerBase?.s?.tr,
            },
        }) ?? {}
    );
};
